import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";

export default function LoginConsentModal() {
  const { consentOpen, setConsentOpen } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  if (!consentOpen) return null;

  const close = () => {
    setConsentOpen(false);
    setAccepted(false);
  };

  const proceed = () => {
    if (!accepted) return;
    try {
      window.localStorage.setItem("cgu_accepted_at", new Date().toISOString());
    } catch (e) {
      // ignore
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  const goLegal = (path) => {
    close();
    navigate(path);
  };

  return (
    <div
      data-testid="consent-modal-overlay"
      className="fixed inset-0 z-[100] bg-[#0A0A0A]/70 flex items-center justify-center p-4"
      onClick={close}
    >
      <div
        data-testid="consent-modal"
        className="bg-[#F4F4F0] border-2 border-[#0A0A0A] shadow-brutal max-w-md w-full p-6 md:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#FF3B30] font-bold mb-3">
          // ACCÈS SÉCURISÉ
        </p>
        <h2 className="font-display text-2xl uppercase tracking-tight text-[#0A0A0A] mb-4">
          {t("consent_title")}
        </h2>
        <p className="font-mono-corp text-sm text-[#4B4B4B] leading-relaxed mb-5">
          {t("consent_body")}
        </p>

        <label
          data-testid="consent-checkbox-label"
          className="flex items-start gap-3 cursor-pointer mb-6 border-2 border-[#0A0A0A] bg-white p-3"
        >
          <input
            data-testid="consent-checkbox"
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="mt-1 w-4 h-4 accent-[#FF3B30] flex-shrink-0"
          />
          <span className="text-xs uppercase tracking-wide text-[#0A0A0A] leading-relaxed">
            {t("consent_checkbox_pre")}{" "}
            <button
              type="button"
              data-testid="consent-link-cgu"
              onClick={() => goLegal("/legal/cgu")}
              className="underline font-bold hover:text-[#FF3B30]"
            >
              {t("footer_legal_cgu")}
            </button>{" "}
            {t("consent_and")}{" "}
            <button
              type="button"
              data-testid="consent-link-privacy"
              onClick={() => goLegal("/legal/privacy")}
              className="underline font-bold hover:text-[#FF3B30]"
            >
              {t("footer_legal_privacy")}
            </button>
            .
          </span>
        </label>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            data-testid="consent-continue-btn"
            onClick={proceed}
            disabled={!accepted}
            className="flex-1 bg-[#FF3B30] text-white border-2 border-[#0A0A0A] font-display text-sm uppercase tracking-widest px-6 py-3 shadow-brutal-sm transition-all enabled:hover:translate-x-[2px] enabled:hover:translate-y-[2px] enabled:hover:shadow-none disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {t("consent_continue")} →
          </button>
          <button
            data-testid="consent-cancel-btn"
            onClick={close}
            className="bg-white text-[#0A0A0A] border-2 border-[#0A0A0A] font-display text-sm uppercase tracking-widest px-6 py-3 hover:bg-[#FFCC00] transition-colors"
          >
            {t("consent_cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
